import { initI18n } from "./locales/i18n";
import { loadSSOTokens } from "./utils/sso_utils";

export const officeReadyPromise = new Promise<void>((resolve, reject) => {
  Office.onReady(async (info) => {
    if (info.host === Office.HostType.Word) {
      await initI18n();
      await loadSSOTokens();
      resolve();
    } else {
      reject(new Error("Host is not Word"));
    }
  });
});
